import { all } from 'redux-saga/effects';

import account from './account';
import admin from './admin';
import appManagement from "./appManagement";
import appConfig from "./appConfig";
import transaction from "./transaction";
import superApp from "./superApp";

const sagas = [
    ...account,
    ...admin,
    ...appManagement,
    ...appConfig,
    ...transaction,
    ...superApp,
];

function* rootSaga() {
    yield all(sagas);
}

export default rootSaga;